// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type TradePartnersSelectQueryVariables = Types.Exact<{
  filter: Types.TradePartnerFilter;
}>;


export type TradePartnersSelectQuery = { __typename?: 'Query', tradePartners: Array<{ __typename?: 'TradePartner', id: string, name: string }> };


export const TradePartnersSelectDocument = gql`
    query TradePartnersSelect($filter: TradePartnerFilter!) {
  tradePartners(filter: $filter) {
    ...Named
  }
}
    ${NamedFragmentDoc}`;

/**
 * __useTradePartnersSelectQuery__
 *
 * To run a query within a React component, call `useTradePartnersSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradePartnersSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradePartnersSelectQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTradePartnersSelectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TradePartnersSelectQuery, TradePartnersSelectQueryVariables> & ({ variables: TradePartnersSelectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TradePartnersSelectQuery, TradePartnersSelectQueryVariables>(TradePartnersSelectDocument, options);
      }
export function useTradePartnersSelectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TradePartnersSelectQuery, TradePartnersSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TradePartnersSelectQuery, TradePartnersSelectQueryVariables>(TradePartnersSelectDocument, options);
        }
// @ts-ignore
export function useTradePartnersSelectSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TradePartnersSelectQuery, TradePartnersSelectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TradePartnersSelectQuery, TradePartnersSelectQueryVariables>;
export function useTradePartnersSelectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TradePartnersSelectQuery, TradePartnersSelectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TradePartnersSelectQuery | undefined, TradePartnersSelectQueryVariables>;
export function useTradePartnersSelectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TradePartnersSelectQuery, TradePartnersSelectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TradePartnersSelectQuery, TradePartnersSelectQueryVariables>(TradePartnersSelectDocument, options);
        }
export type TradePartnersSelectQueryHookResult = ReturnType<typeof useTradePartnersSelectQuery>;
export type TradePartnersSelectLazyQueryHookResult = ReturnType<typeof useTradePartnersSelectLazyQuery>;
export type TradePartnersSelectSuspenseQueryHookResult = ReturnType<typeof useTradePartnersSelectSuspenseQuery>;
export type TradePartnersSelectQueryResult = ApolloReactCommon.QueryResult<TradePartnersSelectQuery, TradePartnersSelectQueryVariables>;